export const data = [
  {
    title: "Is ChainPulse safe to use?",
    text: "Yes, ChainPulse is completely safe and secure to use. We only access and read your wallet's address. You can even test it by entering a random Solana Address into the app.",
    isChecked: true,
  },
  {
    title: "What Data can ChainPulse give me?",
    text: (
      <div>
        ChainPulse provides you with detailed information including:
        <br />
        <br />
        <ul>
          <li>Token and NFT metadata</li>
          <li>Profit and loss views</li>
          <li>Solana transaction history for your wallet's entire lifetime</li>
        </ul>
        <br />
        <br />
      </div>
    ),
  },
  {
    title: "Why should I use ChainPulse?",
    text: "ChainPulse simplifies the process of monitoring your portfolio, including token balances, yield farms, and NFTs. It's the only portfolio manager on Solana that offers detailed profit and loss reports along with informative graphs for your holdings.",
    isChecked: true,
  },
  {
    title: "Is ChainPulse free to use?",
    text: "Absolutely! ChainPulse is entirely free to use. There are no charges or minimum token holdings required to access its features.",
    isChecked: true,
  },
];
